(() => {
  if (window.__ng21Motion) return;
  window.__ng21Motion = true;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const SELECTORS = [
    '.hero-v21__content',
    '.hero-v21__media',
    '.scrolling-messages-v21',
    '.featured-logos-v21__inner',
    '.bestsellers-v21__inner',
    '.icon-with-text-v21__inner',
    '.how-it-works-v21__header',
    '.how-it-works-v21__media',
    '.how-it-works-v21__copy',
    '.get-more-save-more-v21__inner',
    '.why-natural-graze-v21__inner',
    '.benefits-v21__inner',
    '.vet-approved-v21__inner',
    '.real-results-v21__inner',
    '.testimonials-v21__intro',
    '.testimonials-v21__slider',
    '.moneyback-guarantee-v21__inner',
    '.reels-section-v21__inner',
    '.faq-v21__inner',
    '.contact-form-v21__inner',
    '.mpb-v21__media',
    '.mpb-v21__info',
    '.pdp-problems-v21__intro',
    '.pdp-problems-v21__card',
    '.pdp-problems-v21__summary',
    '.pdp-formula-v21__inner',
    '.pdp-four-v21__quote',
    '.pdp-four-v21__intro',
    '.pdp-four-v21__card',
    '.pdp-keepers-v21__copy',
    '.pdp-keepers-v21__farm',
    '.pdp-keepers-v21__stat',
    '.pdp-natural-v21__inner',
    '.pdp-spice-v21__media',
    '.pdp-spice-v21__copy',
    '.pdp-feed-v21__intro',
    '.pdp-feed-v21__step',
    '.pdp-feed-v21__guide-wrap',
    '.pdp-timeline-v21__intro',
    '.pdp-timeline-v21__week',
    '.pdp-compare-v21__inner',
    '.pdp-reviews-v21__intro',
    '.pdp-reviews-v21__card',
    '.pdp-faq-v21__intro',
    '.pdp-faq-v21__item',
    '.pdp-risk-v21__inner'
  ];

  const LEFT = [
    'how-it-works-v21__media',
    'hero-v21__media',
    'mpb-v21__media',
    'pdp-spice-v21__media',
    'pdp-keepers-v21__copy'
  ];

  const RIGHT = [
    'how-it-works-v21__copy',
    'hero-v21__content',
    'mpb-v21__info',
    'pdp-spice-v21__copy',
    'pdp-keepers-v21__farm'
  ];

  const markReveals = () => {
    const nodes = document.querySelectorAll(SELECTORS.join(','));
    nodes.forEach((el, i) => {
      if (el.classList.contains('ng-v21-reveal') || el.classList.contains('is-in')) return;
      el.classList.add('ng-v21-reveal');
      LEFT.forEach((cls) => {
        if (el.classList.contains(cls)) el.classList.add('ng-v21-reveal-left');
      });
      RIGHT.forEach((cls) => {
        if (el.classList.contains(cls)) el.classList.add('ng-v21-reveal-right');
      });
      el.style.transitionDelay = reduce ? '0s' : (Math.min(i % 4, 3) * 0.08) + 's';
    });
  };

  const observe = () => {
    markReveals();
    const targets = document.querySelectorAll('.ng-v21-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    targets.forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', observe);
})();
